import ExploreArea from '../../../domain/entities/ExploreArea';
import ExploreStation from '../../../domain/entities/ExploreStation';
import MerchantCategory from '../../../domain/entities/MerchantCategory';

export const SEARCH_AREAS = 'searchAreas';
export const SEARCH_CATEGORIES = 'searchCategories';

export interface State {
  fieldData: {
    exAreas?: ExploreArea[];
    categories?: MerchantCategory[];
    exStations?: ExploreStation[];
  };
}

const initialState = {
  fieldData: {
    categories: [],
    exAreas: [],
    exStations: [],
  },
};

// tslint:disable-next-line:no-any
export default (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_AREAS:
      return {
        ...state,
        ...{
          fieldData: {
            ...state.fieldData,
            ...{ exAreas: payload.exAreas },
            ...{ exStations: payload.exStations },
          },
        },
      };
    case SEARCH_CATEGORIES:
      return {
        ...state,
        ...{
          fieldData: {
            ...state.fieldData,
            ...{ categories: payload.categories },
          },
        },
      };
    default:
      return state;
  }
};
